import {t} from '~/initializers/i18n'
import {goBack} from '~/routing/actions'
import {Select, ModalWithNewForm, Message, EitjeButton, notifications} from '~/components'
import {backend} from '@eitje/api'
import {fileDomain} from '~/initializers/environment'

const ROLES = [
	{id: 'admin', t: 'roles.admin'},
	{id: 'manager', t: 'roles.manager'},
	{id: 'uren_accorderen', t: 'roles.approve_hours'},
	{id: 'uren_schrijven', t: 'roles.write_hours'},
	{id: 'contracten', t: 'roles.contracts'},
	{id: 'financieel', t: 'roles.financial'},
	{id: 'verlof', t: 'roles.leave'},
]

// to align the button to the left, otherwise it grows full width
const inlineStyles = {alignSelf: 'flex-start'}

export const ExportUsers = () => {
	const handleSubmit = selectedRoles => {
		// use .then to be able to handle the response, even after this page has been unmounted
		backend.get('environments/users', selectedRoles).then(afterSubmit)
		goBack()
	}

	const afterSubmit = res => {
		notifications.infoNotif({
			title: t('notifications.exports.user_export'),
			duration: 0,
			colorSet: 'grey-bordered',
			content: <EitjeButton t="common.download" iconLeft="download" style={inlineStyles} externalLink={fileDomain + res.data.url} />,
		})
	}

	return (
		<ModalWithNewForm
			name="user_export"
			onSubmit={handleSubmit}
			modalProps={{okButtonProps: {iconLeft: 'paper-plane', t: 'common.export'}}}
			width={400}
		>
			<Message t={'modals.user_export.message'} />
			<Select field="roles" type="multiple" required items={ROLES} />
		</ModalWithNewForm>
	)
}
